import React, { MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import analytics from 'utils/analytics';
import clsx from 'clsx';
import { ReactComponent as LockIcon } from 'lib/_content/images/icons/lock.svg';

interface MenuItemProps {
    icon?: ReactNode;
    title?: string;
    small?: boolean;
    href?: string;
    to?: string;
    target?: '_self' | '_blank' | '_parent' | '_top';
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    tracking?: boolean;
    trackingAction?: string;
    trackingLabel?: string;
    disabled?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
    icon,
    title = 'Menu Item',
    small,
    href = '#0',
    to,
    target,
    onClick = () => {},
    tracking = false,
    trackingAction = 'LINK_CLICK',
    trackingLabel = 'LINK_CLICK',
    disabled = false,
}) => {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        onClick(event);
        if (tracking) {
            const label = trackingLabel ?? (href || 'LINK_CLICK');
            analytics.sendLinkEvent(trackingAction, label);
        }
    };

    const containerClasses = clsx('menu-item-container', {
        small,
        disabled,
    });

    if (to) {
        return (
            <Link onClick={onClick} to={to} className={containerClasses}>
                <div className="menu-item-content">
                    {icon && <span className="menu-item-icon">{icon}</span>}
                    {title && <p className="menu-item-title">{title}</p>}
                </div>
                <div className="menu-item-arrow">
                    <i className="fa fa-caret-right" />
                </div>
            </Link>
        );
    }

    return (
        <a
            onClick={handleClick}
            href={href}
            target={target}
            className={containerClasses}
        >
            <div className="menu-item-content">
                {icon && <div className="menu-item-icon">{icon}</div>}
                {title && <p className="menu-item-title">{title}</p>}
            </div>
            <div className="menu-item-arrow">
                {disabled ? (
                    <LockIcon
                        style={{
                            width: '16px',
                            height: '16px',
                            marginLeft: '8px',
                        }}
                    />
                ) : (
                    <i className="fa fa-caret-right" />
                )}
            </div>
        </a>
    );
};

export default MenuItem;
